import React, { FC, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { RootState, useDispatch, useSelector } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import CloseIcon from '@material-ui/icons/Close';

import { editTextReset } from 'src/store/modules/editText';
import { buttonsReset } from 'src/store/modules/buttons';
import { imageReset, editCurrentIndex } from 'src/store/modules/imageUpload';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { editUserCompany } from 'src/store/modules/client';
import { customlogReset } from 'src/store/modules/customlog';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/CarouselSlideModalTracking';

const initValue = {
  currentIndex: 0,
  bg: 'color',
  bgOpacity: { bgDimmed: 70 },
  bgImage: {
    multi_image: [
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
    ]
  },
  bgColor: { background: '#ffffff' },
  radius: { background: 14, multi_image: 4, multi_button: 4 },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },

  text: {
    multi_title: ['SALE UP TO 30%', 'SALE UP TO 40%', 'SALE UP TO 50%'],
    multi_sub_title: [
      'If you read New Series more than 3 times, you will receice 3 Coins.',
      'If you read New Series more than 3 times, you will receice 3 Coins.',
      'If you read New Series more than 3 times, you will receice 3 Coins.'
    ]
  },
  fontSize: { multi_title: 1.25, multi_sub_title: 0.8125 },
  fontWeight: { multi_title: 700, multi_sub_title: 400 },
  color: { multi_title: '#000000', multi_sub_title: '#000000' },
  fontFamily: { multi_title: 'Inter', multi_sub_title: 'Inter' },
  textAlign: { multi_title: 'center', multi_sub_title: 'center' },

  btnText: {
    multi_button: ['READ NOW', 'READ NOW', 'READ NOW'],
    multi_left_button: [
      "Don't show again",
      "Don't show again",
      "Don't show again"
    ],
    multi_right_button: ['Close', 'Close', 'Close']
  },
  btnFontSize: {
    multi_button: 0.9375,
    multi_right_button: 0.875,
    multi_left_button: 0.875
  },
  btnFontWeight: {
    multi_button: 700,
    multi_right_button: 400,
    multi_left_button: 400
  },
  btnColor: {
    multi_button: '#ffffff',
    multi_right_button: '#ffffff',
    multi_left_button: '#ffffff'
  },
  btnBgColorR: { multi_button: 0, multi_left_button: 0, multi_right_button: 0 },
  btnBgColorG: {
    multi_button: 220,
    multi_left_button: 0,
    multi_right_button: 0
  },
  btnBgColorB: {
    multi_button: 100,
    multi_left_button: 0,
    multi_right_button: 0
  },
  btnBgColorA: { multi_button: 1, multi_left_button: 0, multi_right_button: 0 },
  btnFontFamily: {
    multi_button: 'Inter',
    multi_right_button: 'Inter',
    multi_left_button: 'Inter'
  },
  btnAgain: {
    type: 'attribute',
    multi_left_button: 'opt-in'
  },
  button1: {
    multi_button: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    multi_image: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    multi_left_button: [],
    multi_right_button: []
  },
  button2: {
    multi_button: [],
    multi_image: [],
    multi_left_button: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    multi_right_button: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
  }
};

const CarouselSlideModal: FC<any> = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const contentsSliderRef = useRef<any>(null);

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  const templateWidth = useSelector(
    (state: RootState) => state.template.templateWidth
  );
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiButtonURL = getFontURL(btnFontFamily?.multi_button);
  const multiLeftButtonURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonURL = getFontURL(btnFontFamily?.multi_right_button);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initValue, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @font-face {
    font-family: 'multiButton';
    src: url(${multiButtonURL});
  }
  @font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonURL});
  }
  @font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonURL});
  }
    
    .root_view {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      position: relative;
      background: none;
    }

    .background {      
      width: 100%;
      height: 100%;
      position: absolute;      
      background: rgba(0, 0, 0, ${displayValue});
      
    }    
    .center {
      width: 310px;      
      position: relative;
      overflow: hidden;
      
      display: flex;
      flex-direction: column;          
    }

    .modal_wrapper {        
      display: flex;
      flex-direction: column;      
      padding-top: 0.8rem;
      border-radius: ${radius?.background}px;

      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
   

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 100%;
      position: relative;
    }
    .slick_wrapper .slick_image_wrapper {                   
      min-width: 16.875rem; 
      max-height: 21.75rem;
      min-height: 11.25rem;
      outline: 0;       
      overflow: hidden;
    }
            
    .slick_wrapper .slick-list {
      padding: 0 -0.3rem;      
    }

    .slick_wrapper .slick-track {
      display: flex;
      align-items: center;
      ${
        bgImage?.multi_image?.length === 1 ? 'justify-content: center;' : ''
      }    
    }
    .slick_wrapper .slick-slide {
      padding: 0 5px;
    }    
  
    .slick_wrapper .slick-track img {
      object-fit: cover;
      object-position: top;
      border-radius: ${radius?.multi_image}px;
    }

    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      background-color: transparent;
    }

    .contents_wrapper {
      width: 100%;
      padding: 0 1.25rem;
    }
    .contents_box {
      width: 100%;
      height: 100%;
      margin-top: 1.25rem;
    }

    .contents_box .title {
      width: 100%;      
      display: flex;
      align-items: center;
      margin-bottom: 7px;
    }
    
    .title .title_inner {
      width: 100%;
      text-align: ${textAlign?.multi_title};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.4;
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 100%
      display: flex;
      align-items: center;
    }
    .contents_box .sub_title_inner {
      width: 100%;  
      text-align: ${textAlign?.multi_sub_title};
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 1.54;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .slick_page {
      padding: 0.19rem 0.5rem;
      position: absolute;
      right: 26px;
      bottom: 0.5rem;
      
      display: flex;
      gap: 0.2rem;
      
      color: #ffffff;
      font-family: Roboto;
      font-size: 0.7rem;
      font-weight: 400;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .btn_wrapper {
      width: 100%;
      margin: 1rem 0rem 1.25rem 0rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;
      padding: 0 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily.multi_button
          : 'multiButton'
      };
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

    .bottom_wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 11px
    }
    
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.multi_left_button};      
      font-weight: ${btnFontWeight?.multi_left_button};
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily.multi_left_button
          : 'multiLeftButton'
      };
    }
    .bottom_wrapper .style02 {
      width: 100%;
       display:flex;
      justify-content: flex-end;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      color: ${btnColor?.multi_right_button};      
      font-weight: ${btnFontWeight?.multi_right_button};
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily.multi_right_button
          : 'multiRightButton'
      };
    }


    ${
      templateWidth > 767
        ? `
        .modal_wrapper {
          width: 50%;
          height: 36.75rem;
          padding: 2rem 0;
          margin: 0 25%;
        }

        .close_btn {
          right: 25%;
          top: 4rem;
        }

        .slick_wrapper,
        .slick_wrapper .slick-slider,
        .slick_wrapper .slick-list {
          height: 16rem;
          margin-bottom: 1rem;
        }
        .slick_wrapper .slick_image_wrapper {
          max-width: 16rem;
          min-width: 16rem;
          max-height: 16rem;
          min-height: 16rem;
          outline: 0;
        }

        .contents_wrapper {
          width: 100%;
          height: 9rem;
          padding: 0 2rem;
        }
        .contents_box {
          height: 9rem;
        }
        .contents_box .title {
          height: 3.5rem;
          font-size: ${fontSize?.multi_title + 0.25}rem;
        }
        .contents_box .sub_title {
          height: 5rem;
          font-size: ${fontSize?.multi_sub_title + 0.25}rem;
        }

        .btn_wrapper {
          padding: 0 2rem;
          // bottom: 2rem;
        }
        .btn_wrapper button {
          width: 100%;
          height: 4rem;
        }
        `
        : ''
    }

  `;

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    contentsSliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex, bgImage?.multi_image?.length]);

  const settings = {
    arrows: false,
    dots: false,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 0,
    variableWidth: true,
    speed: 300,
    touchThreshold: 300
  };

  const contentsSettings = {
    arrows: false,
    dots: false,
    fade: true,
    swipe: false,
    speed: 300
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="center">
          <div className="modal_wrapper">
            <div className="slick_wrapper">
              <Slider
                {...settings}
                ref={sliderRef}
                afterChange={index => {
                  dispatch(editCurrentIndex(index));
                  contentsSliderRef.current.slickGoTo(index);
                }}
              >
                {bgImage?.multi_image?.map((data: any, idx: number) => (
                  <img
                    key={idx}
                    className="slick_image_wrapper"
                    src={data}
                    alt="이미지"
                    decoding="async"
                    loading="lazy"
                  />
                ))}
              </Slider>
              {bgImage?.multi_image?.length !== 1 && (
                <div className="slick_page">
                  <span>{currentIndex + 1}</span>
                  <span className="slash" style={{ color: '#828282' }}>
                    /
                  </span>
                  <span style={{ color: '#828282' }}>
                    {bgImage?.multi_image?.length}
                  </span>
                </div>
              )}
            </div>
            <div className="contents_wrapper">
              <Slider {...contentsSettings} ref={contentsSliderRef}>
                {text?.multi_title?.map((data: any, idx: number) => (
                  <div key={idx} className="contents_box">
                    <div className="title">
                      <div className="title_inner">
                        {changeEnter(text?.multi_title?.[idx])}
                      </div>
                    </div>
                    <div className="sub_title">
                      <div className="sub_title_inner">
                        {changeEnter(text?.multi_sub_title?.[idx])}
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>

              <div className="btn_wrapper">
                <button>{btnText?.multi_button?.[currentIndex]}</button>
              </div>
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01">
              {btnText?.multi_left_button?.[currentIndex]}
            </span>
            <span className="style02">
              {btnText?.multi_right_button?.[currentIndex]}
              <CloseIcon
                style={{
                  fontSize: `${btnFontSize?.multi_right_button + 0.25}rem`
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

// const setValue = (
//   dispatch: any,
//   values: any,
//   initValues: any,
//   clientName: any
// ) => {
//   const MultiBackground = values?.imageName?.map((data: any) => {
//     return `https://image.inappmessage.com/${clientName}/${data}`;
//   });
//   dispatch(
//     editBgImage({
//       multi_image: MultiBackground
//     })
//   );

//   dispatch(
//     editDeeplink({
//       multi_image: values?.newDeepLink
//     })
//   );
//   dispatch(
//     editRadius({
//       background: values?.newBodyRadius,
//       multi_image: values?.newImgRadius,
//       multi_button: values?.newBtnRadius
//     })
//   );

//   const newText = values?.newText?.map((data: any) => {
//     return changeText(data);
//   });
//   const newSubText = values?.newSubText?.map((data: any) => {
//     return changeText(data);
//   });
//   dispatch(
//     editText({
//       multi_title: newText,
//       multi_sub_title: newSubText
//     })
//   );
//   dispatch(
//     editPreFontSize({
//       multi_title: values?.newFontSize / 16,
//       multi_sub_title: values?.newSubFontSize / 16
//     })
//   );
//   dispatch(
//     editFontSize({
//       multi_title: values?.newFontSize / 16,
//       multi_sub_title: values?.newSubFontSize / 16
//     })
//   );
//   dispatch(
//     editFontWeight({
//       multi_title: values?.newFontWeight,
//       multi_sub_title: values?.newSubFontWeight
//     })
//   );
//   dispatch(
//     editColor({
//       multi_title: values?.newTextColor,
//       multi_sub_title: values?.newSubTextColor
//     })
//   );
//   // dispatch(editFontFamily(values?.fontFamily));
//   // dispatch(editTextAlign(values?.textAlign));

//   const newBtnText = values?.newBtnText?.map((data: any) => {
//     return changeText(data);
//   });
//   dispatch(
//     editBtnText({
//       multi_button: newBtnText
//     })
//   );
//   dispatch(
//     editBtnPreFontSize({
//       multi_button: values?.newBtnFontSize / 16
//     })
//   );
//   dispatch(
//     editPreFontSize({
//       multi_button: values?.newBtnFontSize / 16
//     })
//   );
//   dispatch(
//     editBtnFontWeight({
//       multi_button: values?.newBtnFontWeight
//     })
//   );
//   dispatch(
//     editBtnColor({
//       multi_button: values?.newBtnTextColor
//     })
//   );
//   dispatch(
//     editBtnBgColor(
//       { multi_button: values?.BtnBgColorR },
//       { multi_button: values?.BtnBgColorG },
//       { multi_button: values?.BtnBgColorB },
//       { multi_button: values?.BtnBgColorA }
//     )
//   );
//   //     dispatch(editBtnFontFamily(values?.btnFontFamily));
//   //     dispatch(editBtnTextAlign(values?.btnTextAlign));
// };

export default CarouselSlideModal;
